import React from 'react';
import { Row, Col, Form } from "react-bootstrap";
import "../../sass/main.scss";
import './FormField.scss';

export interface DropdownOption {
    label: string,
    value?: string | number | readonly string[],
    hidden?: boolean,
    disabled?: boolean,
    rid?: string,
}

interface DropdownFieldProps {
    label?: string,
    required?: boolean,
    errMsg?: string,
    onChange: (event: React.ChangeEvent<HTMLSelectElement>, previous?: string | number | readonly string[]) => void,
    onBlur?: (event: React.FocusEvent<HTMLSelectElement, Element>) => void,
    options: readonly DropdownOption[],
    input?: {value?: string | number | string[]},
    value?: string | number | string[],
    meta: any,
    style?: React.CSSProperties,
    selectStyle?: React.CSSProperties,
    disabled?: boolean,
}

function DropdownField(props: DropdownFieldProps) {
    let errMsg = props.errMsg || ""
    if (props.meta.touched && !props.meta.active && !props.meta.valid) {
        errMsg = props.meta.error
    }

    const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(event, props.value ?? props.input?.value);
    }

    return <Form
        className="dropdown-field-input"
        style={props.style}
        onSubmit={e => { e.preventDefault(); }}
    >
        {props.label && <Row>
            <Col>
                <Form.Label>
                    {props.label}
                    {props.required && <span className="required">*</span>}
                </Form.Label>
            </Col>
        </Row>}
        <Row>
            <Col className={errMsg ? "alert-icon-after dropdown-Input" : "dropdown-Input"}>
                <Form.Control
                    style={props.selectStyle}
                    value={props.value ?? props.input?.value ?? ""}
                    type="text"
                    as="select"
                    onBlur={props.onBlur}
                    disabled={props.disabled}
                    onChange={(event) => onChange(event as React.ChangeEvent<HTMLSelectElement>)}
                    className={errMsg ? "inputError dropdown-Input dropdown-Input-style" : "dropdown-Input dropdown-Input-style"}
                >
                    {props.options.map((opt, i) => <option
                        key={i}
                        className="dropdown-options-style"
                        disabled={opt.disabled}
                        hidden={opt.hidden}
                        value={opt.value ?? ""}
                        id={opt.rid}
                    >
                        {opt.label}
                    </option>)}
                </Form.Control>
            </Col>
        </Row>
        {errMsg && <Row>
            <Col>
                <span className="error-message">{errMsg}</span>
            </Col>
        </Row>}
    </Form>
}
export default DropdownField;
